// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"style_toggleWrapper__GApaJ","toggleBody":"style_toggleBody__DCCmY"};